import { Component, OnInit } from '@angular/core';
import {ParamMap} from '@angular/router';
import {forkJoin, of} from 'rxjs';
import {mergeMap} from 'rxjs/operators';
import {Utils} from 'src/app/classes/Utils';
import {Store, Ecommerce} from 'src/app/models/RestModels';
import {SearchObject} from 'src/app/services/Rest';
import {BaseComponent} from '../base/base.component';



@Component({
  selector: 'app-list-ecommerce',
  templateUrl: './list-ecommerce.component.html',
  styleUrls: ['./list-ecommerce.component.css']
})
export class ListEcommerceComponent extends BaseComponent implements OnInit
{
	ecommerce_search: SearchObject<Ecommerce> = this.getEmptySearch();
	ecommerce_list: Ecommerce[] = [];
	store_dict:Record<string,Store> = {};

	ngOnInit(): void
	{
		this.path = 'list-ecommerce';
		this.setTitle('Ecommerce');

		this.subs.sink = this.route.paramMap.pipe
		(
			mergeMap((param_map:ParamMap)=>
			{
				let fields = ['name','id'];
				this.ecommerce_search = this.getSearch(param_map, fields)

				return forkJoin
				({
					ecommerce: this.rest.ecommerce.search(this.ecommerce_search),
					stores: this.rest.getStores(false)
				});
			})
		)
		.subscribe
		({
			next:(response)=>
			{
				this.ecommerce_list = response.ecommerce.data;
				this.setPages( this.ecommerce_search.page, response.ecommerce.total );
			}
			,error:(error)=>
			{
				this.showError( error );
			}
		});
	}
}
